export default __webpack_public_path__ + "static/media/launch-nft-icon.bad5cda9.svg";